'use strict'
import { defineMessages, injectIntl } from 'react-intl'

const DayofMonthMessages = defineMessages({
    'first_short': {
        id: 'invoice.recurring.day_of_month.first_short',
        defaultMessage: 'st',
    },
    'second_short': {
        id: 'invoice.recurring.day_of_month.second_short',
        defaultMessage: 'nd',
    },
    'third_short': {
        id: 'invoice.recurring.day_of_month.third_short',
        defaultMessage: 'rd',
    },
    'something_first_short': {
        id: 'invoice.recurring.day_of_month.something_first_short',
        defaultMessage: 'st',
    },
    'something_second_short': {
        id: 'invoice.recurring.day_of_month.something_second_short',
        defaultMessage: 'nd',
    },
    'something_third_short': {
        id: 'invoice.recurring.day_of_month.something_third_short',
        defaultMessage: 'rd',
    },
    'something_else_short': {
        id: 'invoice.recurring.day_of_month.something_else_short',
        defaultMessage: 'th',
    },
    'last': {
        id: 'invoice.recurring.day_of_month.last',
        defaultMessage: 'Last day',
    },
})

const IntervalTypeMessages = defineMessages({
    daily_label: {
        id: 'invoice.recurring.interval_type.daily_label',
        defaultMessage: 'Daily',
    },
    weekly_label: {
        id: 'invoice.recurring.interval_type.weekly_label',
        defaultMessage: 'Weekly',
    },
    monthly_label: {
        id: 'invoice.recurring.interval_type.monthly_label',
        defaultMessage: 'Monthly',
    },
    yearly_label: {
        id: 'invoice.recurring.interval_type.yearly_label',
        defaultMessage: 'Yearly',
    },
})

const DayofWeekMessages = defineMessages({
    '0_week_label': {
        id: 'invoice.recurring.day_of_week.sunday_label',
        defaultMessage: 'Sunday',
    },
    '1_week_label': {
        id: 'invoice.recurring.day_of_week.monday_label',
        defaultMessage: 'Monday',
    },
    '2_week_label': {
        id: 'invoice.recurring.day_of_week.tuesday_label',
        defaultMessage: 'Tuesday',
    },
    '3_week_label': {
        id: 'invoice.recurring.day_of_week.wednesday_label',
        defaultMessage: 'Wednesday',
    },
    '4_week_label': {
        id: 'invoice.recurring.day_of_week.thursday_label',
        defaultMessage: 'Thursday',
    },
    '5_week_label': {
        id: 'invoice.recurring.day_of_week.friday_label',
        defaultMessage: 'Friday',
    },
    '6_week_label': {
        id: 'invoice.recurring.day_of_week.saturday_label',
        defaultMessage: 'Saturday',
    },
})

const MonthMessages = defineMessages({
    '1_month_label': {
        id: 'invoice.recurring.month.january_label',
        defaultMessage: 'January',
    },
    '2_month_label': {
        id: 'invoice.recurring.month.february_label',
        defaultMessage: 'February',
    },
    '3_month_label': {
        id: 'invoice.recurring.month.march_label',
        defaultMessage: 'March',
    },
    '4_month_label': {
        id: 'invoice.recurring.month.april_label',
        defaultMessage: 'April',
    },
    '5_month_label': {
        id: 'invoice.recurring.month.may_label',
        defaultMessage: 'May',
    },
    '6_month_label': {
        id: 'invoice.recurring.month.june_label',
        defaultMessage: 'June',
    },
    '7_month_label': {
        id: 'invoice.recurring.month.july_label',
        defaultMessage: 'July',
    },
    '8_month_label': {
        id: 'invoice.recurring.month.august_label',
        defaultMessage: 'August',
    },
    '9_month_label': {
        id: 'invoice.recurring.month.september_label',
        defaultMessage: 'September',
    },
    '10_month_label': {
        id: 'invoice.recurring.month.october_label',
        defaultMessage: 'October',
    },
    '11_month_label': {
        id: 'invoice.recurring.month.november_label',
        defaultMessage: 'November',
    },
    '12_month_label': {
        id: 'invoice.recurring.month.december_label',
        defaultMessage: 'December',
    },
})

const EndingTypeMessages = defineMessages({
    never: {
        id: 'invoice.recurring.ending_type.never_label',
        defaultMessage: 'Never ends',
    },
    by: {
        id: 'invoice.recurring.ending_type.by_label',
        defaultMessage: 'Ends by',
    },
    after: {
        id: 'invoice.recurring.ending_type.after_label',
        defaultMessage: 'Ends after',
    },
})

const paymentTermTypeMessages = defineMessages({
    "payment_term.type.fixed_days_label": {
        id: 'payment_term.type.fixed_days_label',
        defaultMessage: 'Due in fixed number of days',
    },
    "payment_term.type.day_of_month_label": {
        id: 'payment_term.type.day_of_month_label',
        defaultMessage: 'Due by certain day of month',
    },
})

const billingMethodMessages = defineMessages({
    "common.billing_method.label.one_time": {
        id: 'common.billing_method.label.one_time',
        defaultMessage: 'One time',
    },
    "common.billing_method.label.monthly": {
        id: 'common.billing_method.label.monthly',
        defaultMessage: 'Monthly',
    },
    "common.billing_method.label.monthly_masculine": {
        id: 'common.billing_method.label.monthly_masculine',
        defaultMessage: 'Monthly',
    },
    "common.billing_method.label.yearly": {
        id: 'common.billing_method.label.yearly',
        defaultMessage: 'Yearly',
    },
    "common.billing_method.label.yearly_masculine": {
        id: 'common.billing_method.label.yearly_masculine',
        defaultMessage: 'Yearly',
    },
})

class LabelHelper {
    static getDayOfMonthLabel(intl, dayOfMonth) {
        switch (dayOfMonth) {
            case 1:
            case 21:
                return dayOfMonth + intl.formatMessage(DayofMonthMessages['first_short'])
            case 2:
            case 22:
                return dayOfMonth + intl.formatMessage(DayofMonthMessages['second_short'])
            case 3:
            case 23:
                return dayOfMonth + intl.formatMessage(DayofMonthMessages['third_short'])
            case 31:
                return intl.formatMessage(DayofMonthMessages['last'])
            default:
                return dayOfMonth + intl.formatMessage(DayofMonthMessages['something_else_short'])
        }
    }

    static getDayofWeekLabel(intl, dayOfWeek) {
        if (dayOfWeek >= 0 && dayOfWeek <= 6) {
            return intl.formatMessage(DayofWeekMessages[dayOfWeek + '_week_label'])
        }
        return ''
    }

    static getMonthLabel(intl, month) {
        if (month >= 1 && month <= 12) {
            return intl.formatMessage(MonthMessages[month + '_month_label'])
        }
        return ''
    }

    static getIntervalTypeLabel(intl, intervalType) {
        switch (intervalType) {
            case 'daily':
            case 'weekly':
            case 'monthly':
            case 'yearly':
                return intl.formatMessage(IntervalTypeMessages[intervalType + '_label'])
        }
        return ''
    }

    static getEndingTypeLabel(intl, endingType) {
        switch (endingType) {
            case 'never':
            case 'after':
            case 'by':
                return intl.formatMessage(EndingTypeMessages[endingType])
        }
        return ''
    }

    static getPaymentTermDueTypeLabel(intl, type) {
        switch (type) {
            case 'fixed-days':
                return intl.formatMessage(paymentTermTypeMessages['payment_term.type.fixed_days_label'])
            case 'day-of-month':
                return intl.formatMessage(paymentTermTypeMessages['payment_term.type.day_of_month_label'])
        }
        return ''
    }

    static getBillingMethodLabel(intl, billingMethod, masculine) {
        switch (billingMethod) {
            case "one-time":
                return intl.formatMessage(billingMethodMessages['common.billing_method.label.one_time'])
            case "monthly":
                if (masculine) {
                    return intl.formatMessage(billingMethodMessages['common.billing_method.label.monthly_masculine'])
                } else {
                    return intl.formatMessage(billingMethodMessages['common.billing_method.label.monthly'])
                }
            case "yearly":
                if (masculine) {
                    return intl.formatMessage(billingMethodMessages['common.billing_method.label.yearly_masculine'])
                } else {
                    return intl.formatMessage(billingMethodMessages['common.billing_method.label.yearly'])
                }

        }
        return ''
    }
}


export default injectIntl(LabelHelper)


// WEBPACK FOOTER //
// ./src/common/LabelHelper.jsx